import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\CommunityController::store
* @see app/Http/Controllers/Creator/CommunityController.php:83
* @route '/app/creator/community/channels'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/community/channels',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CommunityController::store
* @see app/Http/Controllers/Creator/CommunityController.php:83
* @route '/app/creator/community/channels'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CommunityController::store
* @see app/Http/Controllers/Creator/CommunityController.php:83
* @route '/app/creator/community/channels'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::store
* @see app/Http/Controllers/Creator/CommunityController.php:83
* @route '/app/creator/community/channels'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::store
* @see app/Http/Controllers/Creator/CommunityController.php:83
* @route '/app/creator/community/channels'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\CommunityController::batch
* @see app/Http/Controllers/Creator/CommunityController.php:55
* @route '/app/creator/community/channels/batch'
*/
export const batch = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batch.url(options),
    method: 'post',
})

batch.definition = {
    methods: ["post"],
    url: '/app/creator/community/channels/batch',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CommunityController::batch
* @see app/Http/Controllers/Creator/CommunityController.php:55
* @route '/app/creator/community/channels/batch'
*/
batch.url = (options?: RouteQueryOptions) => {
    return batch.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CommunityController::batch
* @see app/Http/Controllers/Creator/CommunityController.php:55
* @route '/app/creator/community/channels/batch'
*/
batch.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batch.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::batch
* @see app/Http/Controllers/Creator/CommunityController.php:55
* @route '/app/creator/community/channels/batch'
*/
const batchForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: batch.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::batch
* @see app/Http/Controllers/Creator/CommunityController.php:55
* @route '/app/creator/community/channels/batch'
*/
batchForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: batch.url(options),
    method: 'post',
})

batch.form = batchForm

/**
* @see \App\Http\Controllers\Creator\CommunityController::uploadIcon
* @see app/Http/Controllers/Creator/CommunityController.php:120
* @route '/app/creator/community/channels/icon'
*/
export const uploadIcon = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: uploadIcon.url(options),
    method: 'post',
})

uploadIcon.definition = {
    methods: ["post"],
    url: '/app/creator/community/channels/icon',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\CommunityController::uploadIcon
* @see app/Http/Controllers/Creator/CommunityController.php:120
* @route '/app/creator/community/channels/icon'
*/
uploadIcon.url = (options?: RouteQueryOptions) => {
    return uploadIcon.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CommunityController::uploadIcon
* @see app/Http/Controllers/Creator/CommunityController.php:120
* @route '/app/creator/community/channels/icon'
*/
uploadIcon.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: uploadIcon.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::uploadIcon
* @see app/Http/Controllers/Creator/CommunityController.php:120
* @route '/app/creator/community/channels/icon'
*/
const uploadIconForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: uploadIcon.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::uploadIcon
* @see app/Http/Controllers/Creator/CommunityController.php:120
* @route '/app/creator/community/channels/icon'
*/
uploadIconForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: uploadIcon.url(options),
    method: 'post',
})

uploadIcon.form = uploadIconForm

/**
* @see \App\Http\Controllers\Creator\CommunityController::update
* @see app/Http/Controllers/Creator/CommunityController.php:95
* @route '/app/creator/community/channels/{channel}'
*/
export const update = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/creator/community/channels/{channel}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\CommunityController::update
* @see app/Http/Controllers/Creator/CommunityController.php:95
* @route '/app/creator/community/channels/{channel}'
*/
update.url = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { channel: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { channel: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            channel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        channel: typeof args.channel === 'object'
        ? args.channel.id
        : args.channel,
    }

    return update.definition.url
            .replace('{channel}', parsedArgs.channel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CommunityController::update
* @see app/Http/Controllers/Creator/CommunityController.php:95
* @route '/app/creator/community/channels/{channel}'
*/
update.put = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::update
* @see app/Http/Controllers/Creator/CommunityController.php:95
* @route '/app/creator/community/channels/{channel}'
*/
const updateForm = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::update
* @see app/Http/Controllers/Creator/CommunityController.php:95
* @route '/app/creator/community/channels/{channel}'
*/
updateForm.put = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\CommunityController::destroy
* @see app/Http/Controllers/Creator/CommunityController.php:106
* @route '/app/creator/community/channels/{channel}'
*/
export const destroy = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/community/channels/{channel}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\CommunityController::destroy
* @see app/Http/Controllers/Creator/CommunityController.php:106
* @route '/app/creator/community/channels/{channel}'
*/
destroy.url = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { channel: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { channel: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            channel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        channel: typeof args.channel === 'object'
        ? args.channel.id
        : args.channel,
    }

    return destroy.definition.url
            .replace('{channel}', parsedArgs.channel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CommunityController::destroy
* @see app/Http/Controllers/Creator/CommunityController.php:106
* @route '/app/creator/community/channels/{channel}'
*/
destroy.delete = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::destroy
* @see app/Http/Controllers/Creator/CommunityController.php:106
* @route '/app/creator/community/channels/{channel}'
*/
const destroyForm = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::destroy
* @see app/Http/Controllers/Creator/CommunityController.php:106
* @route '/app/creator/community/channels/{channel}'
*/
destroyForm.delete = (args: { channel: number | { id: number } } | [channel: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const channels = {
    store: Object.assign(store, store),
    batch: Object.assign(batch, batch),
    uploadIcon: Object.assign(uploadIcon, uploadIcon),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default channels